// Element design system: the @layer reset/element priority pin lives in
// gatsby-ssr.js (onRenderBody) as an inline <head> style — bundle import
// order is not deterministic enough to guarantee it parses first.
// Scoped Bootstrap build: every rule is guarded with
// :where(html:not([data-element-page])) so element pages run Bootstrap-free
// (see src/services/element-pages.ts). Regenerate with `yarn generate:bootstrap`.
import 'src/styles/generated/bootstrap-scoped.css';

// Self-hosted fonts (replaces render-blocking fonts.googleapis.com stylesheet).
// Weights mirror the previous gatsby-plugin-google-fonts config; @fontsource
// ships font-display: swap and unicode-range subsets by default.
import '@fontsource/poppins/300.css';
import '@fontsource/poppins/400.css';
import '@fontsource/poppins/400-italic.css';
import '@fontsource/poppins/600.css';
import '@fontsource/poppins/700.css';
import '@fontsource/poppins/900.css';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/400-italic.css';
import '@fontsource/roboto/700.css';
import '@fontsource/roboto/900.css';
// DS labels are Poppins medium; the other Poppins weights load above.
import '@fontsource/poppins/500.css';
import '@fontsource-variable/material-symbols-rounded';

// Element design system (spike): reset + tokens, then the CORGI brand theme
// (must follow theme.css — equal-specificity :root, source order decides),
// then unlayered fixes for clashes with bootstrap/site globals.
import '@chptech/element/reset.css';
import '@chptech/element/theme.css';
import 'src/styles/element-corgi-theme.css';
import 'src/styles/element-overrides.css';

import PageElement from 'src/services/PageElement';
import StoreProvider from 'src/services/StoreProvider';
import { redirectToPlansPageFromJourneyMiddle } from 'src/utils/on-page-reload-helper';

export const wrapRootElement = StoreProvider;

export const onClientEntry = () => {
  window.onload = () => redirectToPlansPageFromJourneyMiddle();
};

// Wraps every page in a component
export const wrapPageElement = PageElement;
